/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RematchRooms202Response
 */
export interface RematchRooms202Response {
    /**
     * Comparison ID to poll for results
     * @type {number}
     * @memberof RematchRooms202Response
     */
    comparisonId: number;
    /**
     * Status message
     * @type {string}
     * @memberof RematchRooms202Response
     */
    message: string;
}

/**
 * Check if a given object implements the RematchRooms202Response interface.
 */
export function instanceOfRematchRooms202Response(value: object): value is RematchRooms202Response {
    if (!('comparisonId' in value) || value['comparisonId'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function RematchRooms202ResponseFromJSON(json: any): RematchRooms202Response {
    return RematchRooms202ResponseFromJSONTyped(json, false);
}

export function RematchRooms202ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RematchRooms202Response {
    if (json == null) {
        return json;
    }
    return {
        
        'comparisonId': json['comparisonId'],
        'message': json['message'],
    };
}

export function RematchRooms202ResponseToJSON(json: any): RematchRooms202Response {
    return RematchRooms202ResponseToJSONTyped(json, false);
}

export function RematchRooms202ResponseToJSONTyped(value?: RematchRooms202Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comparisonId': value['comparisonId'],
        'message': value['message'],
    };
}

